import React, { FC, PropsWithChildren } from 'react'
import { IMediaDelivery } from '@shared/Types'
import { Box, Chip, styled, SxProps, Theme } from '@mui/material'
import { IBreadcrumbConfig, UIBreadcrumb } from '@shared/UIStyleds'

interface IProps {
  value?: Partial<IMediaDelivery>
  breadcrumbConfig: IBreadcrumbConfig[]
  sx?: SxProps<Theme>
}

export const TopBar: FC<PropsWithChildren<IProps>> = (props) => (
  <Box sx={{ display: 'flex', alignItems: 'center', height: '56px', gap: '10px', ...props.sx }}>
    <UIBreadcrumb configs={props.breadcrumbConfig} />
    <Box sx={{ display: 'flex', alignItems: 'center', padding: '0 12px', gap: '8px' }}>
      {props.value?.ContentType && <CustomChip label={props.value?.ContentType} size='small' />}
      {props.value?.MediaType && <CustomChip label={props.value?.MediaType} size='small' />}
    </Box>
    <Box sx={{ flex: 1 }} />
    {props.children}
  </Box>
)

const CustomChip = styled(Chip)({
  fontStyle: 'italic',
  color: '#606060',
  fontSize: '11px',
  fontWeight: 600
})
